import React, { useEffect, useState } from "react";
import "../../../src/App.css";
import { useNavigate } from "react-router-dom";

import {
  filtericon,
  searchicon,
  mapicon,
  leftarrow,
} from "../../assets/Exportimageicon";

import Footer from "../../Components/footer/Footer";

import service from "../../services/service";
import endpoints from "../../services/endpoints";

const Challenges = () => {
  const [search, setSearch] = useState("");
  const [challenges, setChallenges] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // PAGINATION STATES
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // FETCH CHALLENGES API
  const getChallenges = async (page = 1) => {
    try {
      setLoading(true);

      const res = await service.get(
        `${endpoints.challenges.missionManagementChallenges}?page=${page}&limit=16`,
      );
      
      const rawData = res?.data?.data?.data || [];
      
      // Filter out any challenges where status is "draft"
      const nonDraftChallenges = rawData.filter(
        (item) => item?.status?.toLowerCase() !== "draft"
      );
      
      setChallenges(nonDraftChallenges);

      // PAGINATION DATA
      setCurrentPage(res?.data?.data?.currentPage || 1);
      setTotalPages(res?.data?.data?.totalPages || 1);
    } catch (error) {
      console.log("CHALLENGES ERROR", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getChallenges(currentPage);
  }, [currentPage]);

  // SEARCH FILTER
  const filteredChallenges = challenges?.filter((item) =>
    item?.missionName?.toLowerCase().includes(search.toLowerCase()),
  );

  // HANDLE PAGE CHANGE
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);

      // OPTIONAL SCROLL TOP
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="challenges-container">
      <h2 style={{ marginLeft: "9vw" }} className="challenge-title">Featured Challenges</h2>

      <div className="controls-row" style={{ maxWidth: "calc(100% - 115px - 13%)" }}>
        {/* Search Bar */}
        <div className="search-wrapper">
          <input
            type="text"
            placeholder="Search by challenge Name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="search-input"
          />

          <img src={searchicon} alt="Search" className="search-icon" />
        </div>
      </div>

      <div className="featured-challenges mt-4">
        <div className="container">
          {loading ? (
            <p className="text-white">Loading...</p>
          ) : filteredChallenges?.length > 0 ? (
            <>
              {/* CHALLENGES GRID */}
              <div className="challenges-grid">
                {filteredChallenges.map((challenge) => (
                  <div
                    className="challenge-card"
                    key={challenge?.id}
                    onClick={() =>
                      navigate(`/challenges/view/${challenge?.id}`)
                    }
                    style={{ cursor: "pointer" }}
                  >
                    {/* IMAGE */}
                    <div className="card-image-area">
                      <img
                        src={
                          challenge?.thumbnailImage ||
                          "https://via.placeholder.com/300"
                        }
                        alt={challenge?.missionName}
                      />
                    </div>

                    {/* CONTENT */}
                    <div className="card-info-box">
                      <div className="info-content">
                        <h3>{challenge?.missionName}</h3>

                        <div className="distance-row">
                          <img src={mapicon} alt="map icon" />

                          <span>{challenge?.distanceKm} KM</span>
                        </div>
                      </div>

                      {/* ARROW */}
                      <div className="action-arrow">
                        <img src={leftarrow} alt="left arrow" />
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* PAGINATION */}
              <div className="pagination-container">
                {/* PREVIOUS BUTTON */}
                <button
                  className="pagination-btn"
                  disabled={currentPage === 1}
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Prev
                </button>

                {/* PAGE NUMBERS */}
                {[...Array(totalPages)]?.map((_, index) => {
                  const page = index + 1;

                  return (
                    <button
                      key={page}
                      className={`pagination-btn ${
                        currentPage === page ? "active-page" : ""
                      }`}
                      onClick={() => handlePageChange(page)}
                    >
                      {page}
                    </button>
                  );
                })}

                {/* NEXT BUTTON */}
                <button
                  className="pagination-btn"
                  disabled={currentPage === totalPages}
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </button>
              </div>
            </>
          ) : (
            <p className="text-white">No challenges found</p>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Challenges;